/**
 * @generated SignedSource<<542e321f2c036ef3c347c5164a9dad42>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TeeSheetAgendaSidebarFragment_facility$data = {
  readonly club: {
    readonly supportsPrivate: boolean;
  } | null | undefined;
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"AgendaDateSelectorControlFragment_facility" | "TeeSheetCourseSelectorControlFragment_facility" | "TeeSheetHoleCountSelectorControl_facility" | "TeeSheetMultipleBookingToggleFragment_Facility" | "facilityToScheduleOption_facility" | "useFacilityGroupSize_facility" | "useFacilityStartEndTime_facility">;
  readonly " $fragmentType": "TeeSheetAgendaSidebarFragment_facility";
};
export type TeeSheetAgendaSidebarFragment_facility$key = {
  readonly " $data"?: TeeSheetAgendaSidebarFragment_facility$data;
  readonly " $fragmentSpreads": FragmentRefs<"TeeSheetAgendaSidebarFragment_facility">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TeeSheetAgendaSidebarFragment_facility",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Club",
      "kind": "LinkedField",
      "name": "club",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "supportsPrivate",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useFacilityStartEndTime_facility"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useFacilityGroupSize_facility"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TeeSheetMultipleBookingToggleFragment_Facility"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TeeSheetCourseSelectorControlFragment_facility"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AgendaDateSelectorControlFragment_facility"
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "facilityToScheduleOption_facility",
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "slug",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Department",
          "kind": "LinkedField",
          "name": "department",
          "plural": false,
          "selections": [
            (v1/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "args": null,
      "argumentDefinitions": []
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TeeSheetHoleCountSelectorControl_facility"
    }
  ],
  "type": "Facility",
  "abstractKey": null
};
})();

(node as any).hash = "898e78bde197f2c53dc5bc9a26787a07";

export default node;
